/**
 * @desc undefined
 */
import { AccountEntity } from '@eastcoal/api/finance/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryMemberAccountParameter = {
  memberId?: string
}

const method = 'GET'
const url = '/finance/operation/account'

export const queryMemberAccountApi = (
  params?: QueryMemberAccountParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AccountEntity>({
    method,
    url,
    params,
    ...config
  })
}

queryMemberAccountApi.method = method
queryMemberAccountApi.url = url
